<app-bread-crumbs [breadcrumbs]="breadcrumbItems"></app-bread-crumbs>

<div class="blog-details-page pt-110 mb-110">
  <div class="container">
    @if (!isLoading) {
      <div class="row mb-70">
        <div class="col-12">
          <div class="blog-details-author-meta">
            <div class="author-area">
              <div class="author-img">
                <img src="assets/images/avatar.png" alt="" />
              </div>
              <div class="author-content">
                <h6>
                  <span data-translation-key="buyer_homepage_by">{{ 'buyer_homepage.by' | translate }}</span
                    >,
                    <a>{{ blogData?.author }}</a>
                  </h6>
                </div>
              </div>
              <ul>
                <li>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                      d="M8 0C3.60594 0 0 3.60594 0 8C0 12.3941 3.60594 16 8 16C12.3941 16 16 12.3941 16 8C16 3.60594 12.3941 0 8 0ZM11.646 3.69106C11.8291 3.508 12.1259 3.508 12.3089 3.69106C12.492 3.87413 12.492 4.17091 12.3089 4.35397C12.1259 4.53703 11.8291 4.53703 11.646 4.35397C11.463 4.17091 11.463 3.87413 11.646 3.69106ZM7.53125 2.375C7.53125 2.11591 7.74091 1.90625 8 1.90625C8.25909 1.90625 8.46875 2.11591 8.46875 2.375V3.3125C8.46875 3.57159 8.25909 3.78125 8 3.78125C7.74091 3.78125 7.53125 3.57159 7.53125 3.3125V2.375ZM2.375 8.46875C2.11591 8.46875 1.90625 8.25909 1.90625 8C1.90625 7.74091 2.11591 7.53125 2.375 7.53125H3.3125C3.57159 7.53125 3.78125 7.74091 3.78125 8C3.78125 8.25909 3.57159 8.46875 3.3125 8.46875H2.375ZM4.35397 12.3089C4.17091 12.492 3.87413 12.492 3.69106 12.3089C3.508 12.1259 3.508 11.8291 3.69106 11.646C3.87413 11.4629 4.17091 11.4629 4.35397 11.646C4.53703 11.8291 4.53703 12.1259 4.35397 12.3089ZM4.35397 4.35397C4.17091 4.53703 3.87413 4.53703 3.69106 4.35397C3.508 4.17091 3.508 3.87413 3.69106 3.69106C3.87413 3.508 4.17091 3.508 4.35397 3.69106C4.53703 3.87413 4.53703 4.17091 4.35397 4.35397ZM8.46875 13.625C8.46875 13.8841 8.25909 14.0938 8 14.0938C7.74091 14.0938 7.53125 13.8841 7.53125 13.625V12.6875C7.53125 12.4284 7.74091 12.2188 8 12.2188C8.25909 12.2188 8.46875 12.4284 8.46875 12.6875V13.625ZM11.1439 11.1439C10.9608 11.327 10.6642 11.327 10.4811 11.1439L7.66856 8.33141C7.58069 8.24353 7.53125 8.1245 7.53125 8V5.1875C7.53125 4.92841 7.74091 4.71875 8 4.71875C8.25909 4.71875 8.46875 4.92841 8.46875 5.1875V7.80591L11.1439 10.4811C11.327 10.6642 11.327 10.9608 11.1439 11.1439ZM12.3089 12.3089C12.1259 12.492 11.8291 12.492 11.646 12.3089C11.463 12.1259 11.463 11.8291 11.646 11.646C11.8291 11.4629 12.1259 11.4629 12.3089 11.646C12.492 11.8291 12.492 12.1259 12.3089 12.3089ZM14.0938 8C14.0938 8.25909 13.8841 8.46875 13.625 8.46875H12.6875C12.4284 8.46875 12.2188 8.25909 12.2188 8C12.2188 7.74091 12.4284 7.53125 12.6875 7.53125H13.625C13.8841 7.53125 14.0938 7.74091 14.0938 8Z"
                      />
                    </svg>
                    {{ blogData?.date | localDateTime : "shortDate" }}
                  </li>
                  <!-- <li>
                  <svg
                    width="12"
                    height="16"
                    viewBox="0 0 12 16"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                      d="M7.80968 15.0679C9.5273 12.1176 8.80817 8.40483 6.09966 6.24033C6.09808 6.23911 6.0965 6.23758 6.09523 6.23666L6.10694 6.26482L6.10504 6.28594C6.63276 7.63466 6.55873 9.11531 5.91047 10.3857L5.45362 11.2813L5.31347 10.2917C5.21824 9.62039 4.95659 8.98001 4.55353 8.43177H4.48994L4.4564 8.33993C4.46115 9.3657 4.23778 10.3762 3.7996 11.3294C3.22474 12.5768 3.30922 14.0152 4.02581 15.1778L4.52031 15.9804L3.63066 15.6168C2.16361 15.0171 0.990804 13.8618 0.412783 12.4473C-0.234842 10.8678 -0.114934 9.03633 0.733906 7.54925C1.17652 6.77572 1.48657 5.95443 1.65583 5.10773L1.82129 4.27787L2.24334 5.01804C2.44487 5.37098 2.59326 5.75301 2.68532 6.15432L2.69481 6.16381L2.70462 6.22809L2.71379 6.22533C3.97804 4.6002 4.73545 2.57805 4.84586 0.530486L4.87434 0L5.33435 0.290191C7.21173 1.47391 8.51552 3.37301 8.91827 5.5069L8.92744 5.55067L8.93219 5.5574L8.95275 5.52924C9.3207 5.05906 9.51496 4.4998 9.51496 3.91115V2.99956L10.0835 3.72626C11.4053 5.41537 12.083 7.51068 11.9919 9.62651C11.8799 12.117 10.4761 14.3029 8.23648 15.4873L7.26678 16L7.80968 15.0679Z"
                      />
                    </svg>
                    3.9K View
                  </li> -->
                </ul>
              </div>
              <div class="blog-details-thumb">
                <img [src]="blogData?.featured_image" alt="" />
              </div>
            </div>
          </div>
          <div class="row gy-5 mb-70">
            <div class="col-lg-12">
              <div class="blog-details-content">
                <div class="w-post-elm post_content" itemprop="text">
                  <h2>
                    <b>{{ blogData?.title }}</b>
                  </h2>
                  <p>
                    <span
                      [innerHTML]="blogData?.content"
                      style="font-weight: 400"
                    ></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-110">
            <div class="col-12 mb-3">
              <div class="sidebar-area">
                <div class="single-widget">
                  <h5
                    class="widget-title"
                    data-translation-key="buyer_homepage_social_share"
                    >
                    {{ 'buyer_homepage.social_share' | translate }}
                  </h5>
                  <ul class="social-list">
                    <li>
                      <a href="https://www.linkedin.com/">
                        <i class="bi bi-linkedin"></i>
                        <span>LinkedIn</span>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.facebook.com/">
                        <i class="bi bi-facebook"></i>
                        <span>Facebook</span>
                      </a>
                    </li>
                    <li>
                      <a href="https://twitter.com/">
                        <i class="bi bi-twitter-x"></i>
                        <span>Twitter</span>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/">
                        <i class="bi bi-instagram"></i>
                        <span>Instagram</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="details-navigation">
                <div
                  class="single-navigation"
                  [class.disabled]="blogData?.previous_post == null"
                  >
                  <a
                    [routerLink]="['/blog-details', blogData?.previous_post?.slug]"
                    class="nav-btn"
                    data-translation-key="buyer_homepage_previous_post"
                    >
                    <div class="arrow">
                      <svg
                        width="16"
                        height="13"
                        viewBox="0 0 16 13"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M2.58563 6.98704L15.7913 6.98738L15.7913 6.01295L2.58563 6.0133L7.15096 1.44797L6.46232 0.75933L0.72148 6.50017L6.46232 12.241L7.15096 11.5524L2.58563 6.98704Z"
                          stroke-width="0.3"
                          />
                        </svg>
                      </div>
                      {{ 'buyer_homepage.previous_post' | translate }}
                    </a>
                    <div class="content">
                      <h6>
                        <a
                    [routerLink]="[
                      '/blog-details',
                      blogData?.previous_post?.slug
                    ]"
                          >{{ blogData?.previous_post?.name }}</a
                          >
                        </h6>
                      </div>
                    </div>
                    <div
                      class="single-navigation two text-end"
                      [class.disabled]="blogData?.next_post == null"
                      >
                      <div class="content">
                        <h6>
                          <a
                            [routerLink]="['/blog-details', blogData?.next_post?.slug]"
                            >{{ blogData?.next_post?.name }}</a
                            >
                          </h6>
                        </div>
                        <a
                          [routerLink]="['/blog-details', blogData?.next_post?.slug]"
                          class="nav-btn"
                          data-translation-key="buyer_homepage_next_post"
                          >
                          {{ 'buyer_homepage.next_post' | translate }}
                          <div class="arrow">
                            <svg
                              width="16"
                              height="13"
                              viewBox="0 0 16 13"
                              xmlns="http://www.w3.org/2000/svg"
                              >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M13.4144 6.01333L0.208692 6.01299L0.208692 6.98741L13.4144 6.98707L8.84904 11.5524L9.53768 12.241L15.2785 6.5002L9.53768 0.759362L8.84904 1.448L13.4144 6.01333Z"
                                stroke-width="0.3"
                                />
                              </svg>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (isLoading) {
                  <div class="row">
                    @for (item of [1]; track item) {
                      <app-skeleton-loader
                        class="single-widget"
                        type="auction-card"
                      ></app-skeleton-loader>
                    }
                  </div>
                }
              </div>
            </div>
